var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03571 4.725H7.55357V3.20625C7.55357 1.43859 6.18348 0 4.5 0C2.81652 0 1.44643 1.43859 1.44643 3.20625V4.725H0.964286C0.43192 4.725 0 5.17851 0 5.7375V9.7875C0 10.3465 0.43192 10.8 0.964286 10.8H8.03571C8.56808 10.8 9 10.3465 9 9.7875V5.7375C9 5.17851 8.56808 4.725 8.03571 4.725ZM5.94643 4.725H3.05357V3.20625C3.05357 2.36883 3.70246 1.6875 4.5 1.6875C5.29754 1.6875 5.94643 2.36883 5.94643 3.20625V4.725Z",
    fill: "url(#paint0_linear_773_10164)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_773_10164",
    x1: 4.5,
    y1: 0,
    x2: 4.5,
    y2: 10.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D54242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#931D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a1e6f4a42e8b670d641965d9e52fa82d.svg";
export { ForwardRef as ReactComponent };